common.View.create('canvas.blocks.custom.header.Block', {
    onDOMLoad() {
        if (window.innerWidth >= 1024) {
            this.initEffect();
        }
    },

    initEffect() {
        let layerOne = this.element.find('.layer1'),
            layerTwo = this.element.find('.layer2');

        window.addEventListener('mousemove', (e) => {
            let pageX = (e.clientX - window.innerWidth / 2) / 2,
                pageY = (e.clientY - window.innerHeight / 2) / 2,
                multiplierOne = 0.05,
                multiplierTwo = 0.08;

            layerOne.css('transform', `translate(-0%, -0%) translate(${pageX * multiplierOne}px, ${pageY * multiplierOne}px)`);
            layerTwo.css('transform', `translate(-0%, -0%) translate(${pageX * multiplierTwo}px, ${pageY * multiplierTwo}px)`);
        });
    },
});
